<template>
  <div class="popup_in">
    <div class="popup pop-blocked">
      <div class="">
        <img class="" src="/assets/img/svg/clock.svg" />
      </div>
      <div class="title bold tx--blue2">
        בלוק המרפאה עודכן בהצלחה
      </div>
      <div class="pop-blocked-date desk-flex desk-flex--content--center">
        <span>{{ block.end_date }}</span>
        <br />{{ block.start_time }}-{{ block.end_time }}
      </div>
      <div class="text let-1">
        {{ insurance }} {{ block.dup_blocks.length > 1 ? "" : "(ללא חזרה)" }}
      </div>
      <a class="bt_blue w-100" @click="close" href="javascript:void(0);"
        >סגירה</a
      >
    </div>
  </div>
  <!-- End pop-blocked -->
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
//import BlockedBlue from "@/assets/img/svg/blocked-blue.svg";
export default {
  name: "EditBlock",
  props: ["block"],
  data() {
    return {
      app_info: ""
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
      this.$router.go(-1);
    }
  },
  computed: {
    insurance() {
      let ins = [];
      let all_ob = this.block.appointments_ob;
      for (const key in all_ob) {
        if (ins.indexOf(all_ob[key].insurance) < 0) {
          ins.push(all_ob[key].insurance);
        }
      }
      return ins.join(",");
    }
  },
  components: {}
};
</script>

<style scoped></style>
